import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  [
    'inline-flex cursor-pointer items-center justify-center gap-2.5 font-bold transition-colors',
    'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-focus',
    'disabled:pointer-events-none disabled:opacity-50',
  ],
  {
    variants: {
      variant: {
        primary:
          'border border-primary-focus bg-surface-tint text-primary hover:bg-surface-tint/80',
        'primary-dark': 'bg-primary-dark text-white hover:bg-primary-dark/90',
        action: 'bg-action text-white hover:bg-action/90',
        secondary:
          'bg-muted-foreground/10 text-foreground hover:bg-muted-foreground/20',
        'secondary-light': 'bg-surface-muted text-foreground hover:bg-surface-muted/80',
        light: 'bg-white text-primary-dark hover:bg-surface-muted/80',
        dark: 'bg-foreground text-white hover:bg-foreground/90',
      },
      size: {
        default: 'rounded-button px-10 py-4 text-base',
        sm: 'rounded-button-sm px-4 py-2 text-sm',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
)
